<template>
  <el-dialog id="log-crud"
             title="Edit Log"
             @close="close"
             v-loading="loading"
             :element-loading-text="((this.deleting) ? 'Deleting' : 'Saving') + ' Log...'"
             :visible.sync="isVisible"
             :width="(isDialogFullscreen) ? '' : '480px'"
             :fullscreen="isDialogFullscreen">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="user-form">
      <el-form-item label="Task" prop="task_id" v-if="isAdmin">
        <el-select v-model="form.task_id" filterable placeholder="Type to filter">
          <el-option-group
            v-for="group in taskOptions"
            :key="group.label"
            :label="group.label">
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item label="Start Time" prop="startTime">
        <el-time-picker
          v-model="form.startTime"
          :picker-options="{
            selectableRange: '00:00:00 - 23:59:59'
          }"
          format="hh:mm A"
          placeholder="Pick a time">
        </el-time-picker>
      </el-form-item>
      <el-form-item label="End Time" prop="endTime">
        <el-time-picker
          v-model="form.endTime"
          :picker-options="{
            selectableRange: endDateRange
          }"
          format="hh:mm A"
          placeholder="Pick a time">
        </el-time-picker>
      </el-form-item>
      <el-form-item label="Log Date" prop="logDate">
        <el-date-picker
          v-model="form.logDate"
          type="date"
          placeholder="Pick a day"
          format="dd/MM/yyyy"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="Component" prop="tag_id" v-if="projectTags.length">
        <el-select class="tag-select"
                   v-model="form.tag_id"
                   clearable
                   placeholder="Project Component">
          <el-option
              v-for="item in projectTags"
              :key="item.id"
              :label="item.tag"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Comment" prop="comment">
        <el-input v-model="form.comment" type="textarea" auto-complete="off" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger"
                 class="pull-left"
                 @click="deleteLog">Delete</el-button>
      <el-button @click="isVisible = false">Cancel</el-button>
      <el-button type="primary" @click="submit">Save</el-button>
    </span>
    <el-dialog
      width="400px"
      title="Are you sure?"
      :visible.sync="isConfirmDeleteVisible"
      append-to-body>
      <p>The selected log will be <b>permanently deleted!</b></p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isConfirmDeleteVisible = false">Cancel</el-button>
          <el-button type="danger" @click="onConfirmDeleteLog">Delete Log</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'log-crud',
    props: {
      log: null
    },
    data () {
      return {
        isVisible: true,
        isConfirmDeleteVisible: false,
        loading: false,
        windowWidth: 0,

        pickerOptions: {
          disabledDate (time) {
            return time.getTime() > Date.now()
          },
          shortcuts: [{
            text: 'Today',
            onClick (picker) {
              picker.$emit('pick', new Date())
            }
          }, {
            text: 'Yesterday',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          }, {
            text: 'A week ago',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }]
        },

        form: {
          startTime: new Date(),
          endTime: new Date(),
          logDate: new Date(),
          task_id: null,
          tag_id: null,
          comment: ''
        },

        rules: {
          startTime: [
            { type: 'date', required: true, message: 'Start Time is required', trigger: 'change' }
          ],
          endTime: [
            { type: 'date', required: true, message: 'End Time is required', trigger: 'change' }
          ],
          logDate: [
            { type: 'date', required: true, message: 'Log Date is required', trigger: 'change' }
          ],
          task_id: [
            { required: true, message: 'Task is required', trigger: 'change' }
          ]
        }
      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      deleteLog () {
        // Show the delete confirm dialog - dont want any accidents now
        this.isConfirmDeleteVisible = true
      },
      onConfirmDeleteLog () {
        this.isConfirmDeleteVisible = false
        this.$store.dispatch('deleteLog', this.log)
      },
      submit () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // @Note: See watcher 'saving' for the success/error handling of this action
            let startTime = moment(this.form.startTime).format('HH:mm:ss')
            let endTime = moment(this.form.endTime).format('HH:mm:ss')

            // Log date resets to 00:00:00 when changed, we need to reset it's time to the
            // End Time so that the conversion to UTC doesn't go bad
            let logDate = moment(this.form.logDate).format('YYYY-MM-DD')

            let start = moment(logDate + ' ' + startTime, 'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment(logDate + ' ' + endTime, 'YYYY-MM-DD HH:mm:ss').utc().format('YYYY-MM-DD HH:mm:ss')

            var object = {
              id: this.log.id,
              start: start,
              end: end,
              tag_id: this.form.tag_id,
              comment: this.form.comment
            }

            if (this.isAdmin) {
              object.task_id = this.form.task_id
            }

            this.$store.dispatch('updateLog', object)
          } else {
            return false
          }
        })
      },
      setLogDetails () {
        this.form.startTime = moment.utc(this.log.start).local().toDate()
        this.form.endTime = moment.utc(this.log.end).local().toDate()
        this.form.logDate = moment.utc(this.log.end).local().toDate()
        this.form.comment = this.log.comment
        this.form.tag_id = this.log.tag_id
        this.form.task_id = this.log.task_id
      },
      getWindowWidth () {
        this.windowWidth = document.documentElement.clientWidth
      }
    },
    computed: {
      isDialogFullscreen () {
        return this.windowWidth < 520
      },
      saving () {
        return this.$store.state.logs.updateInProgress
      },
      deleting () {
        return this.$store.state.logs.deleteInProgress
      },
      endDateRange () {
        // Restrict the selectable end time to be after the start time
        return moment(this.form.startTime).format('HH:mm:ss') + '-' + '23:59:59'
      },
      task () {
        return this.tasks[this.form.task_id]
      },
      project () {
        if (this.task && this.projects[this.task.project_id]) {
          return this.projects[this.task.project_id]
        } else {
          return null
        }
      },
      projectTags () {
        if (this.project) {
          return this.project.tags
        }
        return []
      },
      taskOptions () {
        let optionsObj = {}
        let options = []
        if (this.isAdmin) {
          // Group Tasks by their Project
          Object.keys(this.tasks)
            .map((k) => this.tasks[k])
            .sort((a, b) => {
              return a.client_name > b.client_name ? 1 : -1
            })
            .map((task) => {
              if (!optionsObj.hasOwnProperty(task.client_name)) {
                optionsObj[task.client_name] = []
              }
              optionsObj[task.client_name].push({
                label: task.project_code + ' - ' + task.title + ' - ' + task.user_full_name,
                value: task.id
              })
            })
          for (let clientName in optionsObj) {
            options.push({
              label: clientName,
              options: optionsObj[clientName].sort((a, b) => {
                return a.label > b.label ? 1 : -1
              })
            })
          }
        }

        return options
      },

      // Vuex Mappings
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      tasks () {
        return this.$store.state.tasks.objects
      },
      projects () {
        return this.$store.state.projects.objects
      },
      tags () {
        return this.$store.state.tags.objects
      }
    },
    mounted () {
      this.setLogDetails()
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth)
        this.getWindowWidth()
      })
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.getWindowWidth)
    },
    watch: {
      'form.task_id' () {
        // When the select task changes, we need to make sure that any select tags
        // are actually available for the new task
        if (this.form.tag_id) {
          // Check the selected tag exists for the new tasks
          let found = false
          for (let i = 0; i < this.projectTags.length; i++) {
            if (this.form.tag_id === this.projectTags[i].id) {
              found = true
              break
            }
          }
          if (!found) {
            this.form.tag_id = null
          }
        }
      },
      'saving' () {
        // If the Log store is either POSTing or PUTing, show the loader if the action is in progress
        // otherwise handle the expected result of a save
        if (this.saving) {
          this.loading = true
        } else {
          this.$message({
            message: 'Log updated!',
            type: 'success'
          })
          this.loading = false
          this.$emit('close')
        }
      },
      'deleting' () {
        // If the Log store is DELETEing, show the loader if the action is in progress
        // otherwise handle the expected result of a save
        if (this.deleting) {
          this.loading = true
        } else {
          this.$message({
            message: 'Log deleted!',
            type: 'success'
          })
          this.loading = false
          this.$emit('close')
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .el-select,
  .el-input {
    width: 100%;
  }
</style>
